module.exports = __webpack_public_path__ + "img/gray-back.96e87074.png";